import React, { useMemo } from 'react'
import { pluralizeToString } from 'lib/string/pluralize'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'
import { unique } from 'lib/array/arrayUtils'

interface Props {
  offer: App.CruiseOffer;
}

function CruiseDescription({ offer }: Props) {
  const cities = useMemo(() => unique((offer.itinerary ?? []).map((event) => {
    const { port } = event
    if (!port) return
    return port.city || port.name.split(',')[0]
  }).filter((city) => city && city.length > 1)).length
  , [offer])

  const countries = useMemo(() => unique((offer.itinerary ?? []).map((itineraryItem) => {
    const { port } = itineraryItem
    if (!port) return
    return port.countryCode
  }).filter(country => country?.length)).length
  , [offer])

  return (
    <Group direction="vertical" gap={8}>
      <BodyText variant="small" colour="neutral-two">
        {offer.cruiseLine.name} · {offer.ship.name}
      </BodyText>
      <BodyText variant="small" colour="neutral-two">
        {pluralizeToString('night', offer.duration)}
        {!!cities && ` · ${pluralizeToString('port', cities)}`}
        {!!countries && ` · ${pluralizeToString('country', countries)}`}
      </BodyText>
    </Group>
  )
}

export default CruiseDescription
